<shared-navigation-top [title]="title"></shared-navigation-top>

<div class="content animation-fade-in">
  <app-card-wrapper></app-card-wrapper>
</div>
